import * as React from 'react';
import LoaderIcon from './LoaderIcon';

const LoaderComponent = (props) => {
    return (
        <div className="loader-container">
            {props.loader.length > 0 ?
            [
                <div key="backdrop" className="loader-backdrop"></div>,
                <LoaderIcon key="loader" />
            ]
                : null}
        </div>
    );
};

export default LoaderComponent;
